
export default {
  name: "MidCTA",
  props: {
    block: { type: Object, required: true },
  },
  computed: {
    buttonClass() {
      return this.block.buttonStyle === "CEDAR" ? "btn-cedar" : "btn-green";
    },
  },
};
